"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PTxId = void 0;
var PTypes_1 = require("../../../PTypes/index.js");
var type_system_1 = require("../../../type_system/index.js");
exports.PTxId = (0, PTypes_1.palias)(type_system_1.bs);
